import React, { useEffect, useState } from 'react';
import { FiBriefcase, FiLogOut, FiMail, FiPlus, FiTrash2 } from 'react-icons/fi';
import { DATA_UPDATED_EVENT, getContacts, getJobs, removeJob, saveJob } from '../dataStore';
import './admin.css';

const ADMIN_USER = 'info@zeitamax.com';
const ADMIN_PASSWORD = 'Zeitamax@009988';
const emptyJob = { title: '', location: '', type: 'Full-time', description: '' };

export default function Admin() {
  const [authenticated, setAuthenticated] = useState(() => sessionStorage.getItem('zeitamax_admin') === 'true');
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [contacts, setContacts] = useState(getContacts);
  const [jobs, setJobs] = useState(getJobs);
  const [job, setJob] = useState(emptyJob);

  useEffect(() => {
    const refresh = () => {
      setContacts(getContacts());
      setJobs(getJobs());
    };
    window.addEventListener(DATA_UPDATED_EVENT, refresh);
    window.addEventListener('storage', refresh);
    return () => {
      window.removeEventListener(DATA_UPDATED_EVENT, refresh);
      window.removeEventListener('storage', refresh);
    };
  }, []);

  const login = (event) => {
    event.preventDefault();
    if (credentials.username === ADMIN_USER && credentials.password === ADMIN_PASSWORD) {
      sessionStorage.setItem('zeitamax_admin', 'true');
      setAuthenticated(true);
      setError('');
      return;
    }
    setError('Incorrect username or password.');
  };

  const logout = () => {
    sessionStorage.removeItem('zeitamax_admin');
    setAuthenticated(false);
    setCredentials({ username: '', password: '' });
  };

  const publishJob = (event) => {
    event.preventDefault();
    saveJob(job);
    setJob(emptyJob);
  };

  if (!authenticated) {
    return (
      <main className="admin-login-page">
        <a className="admin-back" href="#home">Back to website</a>
        <form className="admin-login" onSubmit={login}>
          <div className="admin-mark">ZM</div>
          <span className="admin-kicker">ADMIN PORTAL</span>
          <h1>Welcome back</h1>
          <p>Sign in to manage enquiries and current openings.</p>
          <label>
            <span>Username</span>
            <input type="email" value={credentials.username} onChange={(e) => setCredentials({ ...credentials, username: e.target.value })} required />
          </label>
          <label>
            <span>Password</span>
            <input type="password" value={credentials.password} onChange={(e) => setCredentials({ ...credentials, password: e.target.value })} required />
          </label>
          {error && <div className="admin-error" role="alert">{error}</div>}
          <button className="admin-primary" type="submit">Sign in</button>
        </form>
      </main>
    );
  }

  return (
    <main className="admin-page">
      <header className="admin-header">
        <div>
          <span className="admin-kicker">ZEITAMAX ADMIN</span>
          <h1>Dashboard</h1>
        </div>
        <div className="admin-header-actions">
          <a href="#home">View website</a>
          <button type="button" onClick={logout}><FiLogOut /> Log out</button>
        </div>
      </header>

      <section className="admin-stats" aria-label="Dashboard summary">
        <div><FiMail /><span><strong>{contacts.length}</strong>Contact enquiries</span></div>
        <div><FiBriefcase /><span><strong>{jobs.length}</strong>Published openings</span></div>
      </section>

      <section className="admin-section">
        <div className="admin-section-head"><div><span className="admin-kicker">RECRUITMENT</span><h2>Post a current opening</h2></div></div>
        <form className="job-post-form" onSubmit={publishJob}>
          <label><span>Job title</span><input value={job.title} onChange={(e) => setJob({ ...job, title: e.target.value })} required /></label>
          <label><span>Location</span><input value={job.location} onChange={(e) => setJob({ ...job, location: e.target.value })} placeholder="Remote / Hyderabad" required /></label>
          <label><span>Employment type</span><select value={job.type} onChange={(e) => setJob({ ...job, type: e.target.value })}><option>Full-time</option><option>Contract</option><option>Contract-to-hire</option><option>Part-time</option></select></label>
          <label className="job-description"><span>Description</span><textarea rows="4" value={job.description} onChange={(e) => setJob({ ...job, description: e.target.value })} required /></label>
          <button className="admin-primary" type="submit"><FiPlus /> Publish opening</button>
        </form>

        {jobs.length > 0 && <div className="published-jobs">
          {jobs.map((item) => <article key={item.id}><div><h3>{item.title}</h3><p>{item.location} · {item.type}</p></div><button type="button" title="Remove opening" aria-label={`Remove ${item.title}`} onClick={() => removeJob(item.id)}><FiTrash2 /></button></article>)}
        </div>}
      </section>

      <section className="admin-section">
        <div className="admin-section-head"><div><span className="admin-kicker">ENQUIRIES</span><h2>Contact submissions</h2></div></div>
        <div className="admin-table-wrap">
          <table><thead><tr><th>Name</th><th>Phone</th><th>Email</th><th>Message</th><th>Received</th></tr></thead>
            <tbody>{contacts.length ? contacts.map((contact) => <tr key={contact.id}><td>{contact.name}</td><td>{contact.phone}</td><td><a href={`mailto:${contact.email}`}>{contact.email}</a></td><td>{contact.info}</td><td>{new Date(contact.submittedAt).toLocaleString()}</td></tr>) : <tr><td className="admin-empty" colSpan="5">No contact submissions yet.</td></tr>}</tbody>
          </table>
        </div>
      </section>
    </main>
  );
}
